import { Map } from "immutable";

import SectionStat from "../../../../../../models/Assignee/SectionStat";

type State = Map<string, SectionStat>;

export function getIndividualSectionStats(state: State, sectionId: string) {
  return state.get(sectionId);
}

export function hasSectionStat(state: State, sectionId: string) {
  return !!getIndividualSectionStats(state, sectionId);
}

export function getBestScore(state: SectionStat) {
  return state.get("bestScore");
}

export function getWorstScore(state: SectionStat) {
  return state.get("worstScore");
}

export function getAverageScore(state: SectionStat) {
  return state.get("averageScore");
}

export function getFirstScore(state: SectionStat) {
  return state.get("firstScore");
}

export function getLastScore(state: SectionStat) {
  return state.get("lastScore");
}

export function getSessionsCompleted(state: SectionStat) {
  return state.get("sessionsCompleted");
}

export function getTotalStudyTime(state: SectionStat) {
  return state.get("totalStudyTime");
}
